<template>
  <div class="register clearfix">
    <Form class="registerForm_form" :class="{'no-float': !showRight}" v-if="showLeft" ref="registerForm"
      :rules="registerValidate" :model="registerForm" @submit.native.prevent>
      <h2 class="title">{{ $t('key1006552') }}</h2>
      <Tabs v-model="tabName" :animated="false" @on-click="changeTab" style="width: 100%;">
        <TabPane :label="$t('key1006546')" name="mobileRegister"></TabPane>
        <TabPane :label="$t('key1006547')" name="emailRegister"></TabPane>
      </Tabs>
      <FormItem prop="mobile" v-show="tabName === 'mobileRegister'">
        <Input type="text" clearable v-model.trim="registerForm.mobile" :placeholder="$t('key1003101')">
          <Select slot="prepend" v-model="registerForm.mobileCountryCode" filterable transfer class="reset_select_input">
            <Option v-for="(item, index) in countrysBasisData" :value="item.twoCode" :key="index">{{ item.areaCodeName }}</Option>
          </Select>
        </Input>
      </FormItem>
      <FormItem prop="registerEmail" v-show="tabName === 'emailRegister'">
        <Input type="text" clearable v-model.trim="registerForm.registerEmail" :placeholder="$t('key1003150')"></Input>
      </FormItem>
      <FormItem prop="imageCode">
        <div class="verificationcode_box">
          <Input type="text" clearable style="width: 230px" v-model.trim="registerForm.imageCode" :placeholder="$t('key1001002')"></Input>
          <img :alt="$t('key1001003')" width="110" height="40" :src="captchaImage" @click="getCaptcha"/>
        </div>
      </FormItem>
      <FormItem prop="mobileSms" v-show="tabName === 'mobileRegister'">
        <div class="verificationcode_box" :class="languagesVal !== 'zh-CN' ? 'set_verificationcode_box' : ''">
          <Input type="text" clearable v-model.trim="registerForm.mobileSms" :placeholder="$t('key1001004')"></Input>
          <div class="verificationcode_botton">
            <Button size="large" :disabled="talgCode" @click="sendVerificationCode">
              {{ codeText }}
            </Button>
          </div>
        </div>
      </FormItem>
      <FormItem prop="password">
        <Input type="password" password v-model.trim="registerForm.password" autocomplete="new-password" :placeholder="$t('key1001005')"></Input>
      </FormItem>
      <FormItem prop="password1">
        <Input type="password" password v-model.trim="registerForm.password1" autocomplete="new-password" :placeholder="$t('key1001006')"></Input>
      </FormItem>
      <FormItem prop="email" v-show="tabName === 'mobileRegister'">
        <Input type="text" clearable v-model.trim="registerForm.email" :placeholder="$t('key1006548')"></Input>
      </FormItem>
      <FormItem prop="emailRegisterMobile" v-show="tabName === 'emailRegister'">
        <Input type="text" clearable v-model.trim="registerForm.emailRegisterMobile" :placeholder="$t('key1003101')">
          <Select slot="prepend" v-model="registerForm.mobileCountryCode" filterable transfer class="reset_select_input">
            <Option v-for="(item, index) in countrysBasisData" :value="item.twoCode" :key="index">{{ item.areaCodeName }}</Option>
          </Select>
        </Input>
      </FormItem>
      <FormItem prop="distributorCurrency">
        <Select v-model.trim="registerForm.distributorCurrency" :placeholder="$t('key1001008')" filterable transfer class="reset_select">
          <Option v-for="item in distributorCurrencyList" :label="item.currencyNameCode" :value="item.targetCurrencyCode">{{ item.currencyNameCode }}</Option>
        </Select>
      </FormItem>
      <Checkbox v-model="readTalg" style="margin-bottom: 20px;">
        {{ $t('key1000519') }}
        <a class="select_color" @click.stop="gotoTermsOfService">{{ $t('key1000077') }}</a>
        {{ $t('key1000520') }}
        <a class="select_color" @click.stop="gotoPrivacyPolicy">{{ $t('key1000078') }}</a>
      </Checkbox>
      <Button type="primary" style="width: 100%" @click="registerBtn" size="large">{{ $t('key1001729') }}</Button>
      <ul class="link_box">
        <li class="link_item">
          <img :src="tongtuIcon" :alt="$t('key1006549')"/>
          <span class="txt" @click="toLogin">{{ $t('key1006553') }}</span>
        </li>
      </ul>
    </Form>
    <div class="line" v-if="showMiddle"></div>
    <!--通途账号登录-->
    <div class="tt-auth" v-if="showRight" :class="{'no-float': !showLeft}">
      <p class="title">{{ $t('key1006554') }}</p>
      <p class="tp">{{ $t('key1006555') }}</p>
      <p class="tp">{{ $t('key1006550') + configCharacters() + $t('key1006551') }}</p>
      <login-form v-if="countrysBasisDataTalg" :countrysBasisData="countrysBasisData" :countrysBasisDataTalg="countrysBasisDataTalg" class="mt5"></login-form>
    </div>
    <privacyPolicy ref="privacyPolicy"></privacyPolicy>
    <termsOfService ref="termsOfService"></termsOfService>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import loginForm from '@/views/shopping/login/components/loginForm';
import privacyPolicy from '@/views/shopping/login/commom/privacyPolicy';
import termsOfService from '@/views/shopping/login/commom/termsOfService';
import Mixin from "@/components/mixin/common_mixin";
import {getAdidToken, setAdidToken} from "@/utils/cookie";
import {getAllCountrysData, getAreaCodeByCountryCode, getQueryString} from "@/utils/common";

export default {
  name: "register",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      tongtuIcon: require('@/assets/images/icon-t.png'),
      tabName: 'mobileRegister',
      registerForm: {
        mobile: '',
        mobileCountryCode: 'CN',
        imageCode: '',
        mobileSms: '',
        password: '',
        password1: '',
        distributorCurrency: null,
        email: '',
        registerEmail: '',
        uid: '',
        emailRegisterMobile: ''
      },
      registerValidate: {
        mobile: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000147'), trigger: 'blur'}],
        imageCode: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000989'), trigger: 'blur'}],
        mobileSms: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000990'), trigger: 'blur'}],
        password: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000143'), trigger: 'blur'}],
        password1: [{validator: v.validatenewPassword(), required: true, trigger: 'blur'}],
        email: [{validator: v.validateMailboxFormat(false), required: true, trigger: 'blur'}],
        registerEmail: [{validator: v.validateMailboxFormat(), required: true, trigger: 'blur'}],
        distributorCurrency: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000991'), trigger: 'change'}],
      },
      readTalg: false,
      codeText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000988'),
      talgCode: false,
      captchaImage: '',
      timeStop: null,
      uid: '',
      adid: null,
      countrysBasisData: [],
      countrysBasisDataTalg: false,
      from: '',
      distributorCurrencyList: [],
    };
  },
  created() {
    let {from} = this.$route.query;
    this.from = from;
    getAllCountrysData('en').then((data) => {
      // 默认为中国手机号 +86
      this.countrysBasisData = data;
      this.countrysBasisDataTalg = true;
      this.registerForm.mobileCountryCode = 'CN';
    });
    this.systemCurrencyData();
    this.getCaptcha();
    this.incidentReporting();
  },
  methods: {
    gotoPrivacyPolicy() {
      this.$refs.privacyPolicy.modal = true;
    },
    gotoTermsOfService() {
      this.$refs.termsOfService.modal = true;
    },
    // 校验新密码与旧密码
    validatenewPassword() {
      let v = this;
      let password = function (rule, value, callback) {
        if (!value) {
          return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000997')));
        } else if (v.registerForm.password !== value) {
          return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000998')));
        } else {
          callback();
        }
      };
      return password;
    },
    // 登录
    toLogin(type) {
      let talg = window.location.href.split('//');
      let url = '/index.html#/index';
      let link = '';
      if (talg[1].includes('localhost')) {
        link = `${talg[0]}//${window.location.host}${url}`;
      } else {
        link = `${'/yms-shopping-service' + url}`;
      }
      this.$router.push({
        path: '/login',
        query: {
          u: link,
          type: type
        }
      });
    },
    // 发送手机验证码
    sendVerificationCode() {
      let v = this;
      let talg = false;
      v.$refs.registerForm.validateField("mobile", (error) => {
        if (!error) {
          v.$refs.registerForm.validateField("imageCode", (error) => {
            if (!error) {
              talg = true;
            }
          });
        }
      });
      if (talg) {
        let query = {
          code: v.registerForm.imageCode, // 图片的验证码
          isValidHasRegistry: 0, // 校验是否已注册 1:要校验
          isvalid: 1, // 1 校验图片验证码  0 不校验
          messageType: v.registerForm.mobileCountryCode === 'CN' ? 1 : 14, //  类型 1 注册 2 找回密码 3 绑定手机 4找回邮箱 5 登录 14 海外注册
          mobile: v.registerForm.mobile,
          mobileCountryCode: getAreaCodeByCountryCode(v.countrysBasisData, v.registerForm.mobileCountryCode),
          uid: this.uid
        };
        v.talgCode = true;
        v.axios.post(api.post_ymsUserSetting_sendMobileVerificationCode, query, {
          loading: true
        }).then(response => {
          if (response.data.code === 0) {
            let time = 60;
            clearInterval(v.timeStop);
            v.timeStop = setInterval(() => {
              time--;
              if (time > 0) {
                v.codeText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000995') + time + 'S';
                v.talgCode = true;
              } else {
                time = 60;
                v.codeText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000988');
                clearInterval(v.timeStop); //清除定时器
                v.talgCode = false;
              }
            }, 1000);
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000996'));
          } else {
            v.talgCode = false;
          }
        });
      }
    },
    // 立即注册
    registerBtn() {
      let v = this;
      let validateFieldList = [];
      // 手机号注册
      if (v.tabName === 'mobileRegister') {
        validateFieldList = ['mobile', 'imageCode', 'mobileSms', 'password', 'password1', 'distributorCurrency'];
      }
      // 邮箱注册
      else {
        validateFieldList = ['registerEmail', 'imageCode', 'password', 'password1', 'distributorCurrency'];
      }
      Promise.all(validateFieldList.map(field => {
        const promise = new Promise(function (resolve, reject) {
          v.$refs['registerForm'].validateField(field, (error) => {
            resolve(error);
          });
        });
        return promise;
      })).then((data) => {
        if (data.every(i => !i)) {
          if (v.readTalg) {
            let query = {
              imageCode: v.registerForm.imageCode,
              mobileSms: v.registerForm.mobileSms,
              password: v.registerForm.password,
              uid: v.registerForm.uid,
              adid: v.adid,
              distributorCurrency: v.registerForm.distributorCurrency,
              mobileCountryCode: getAreaCodeByCountryCode(v.countrysBasisData, v.registerForm.mobileCountryCode),
              messageType: v.registerForm.mobileCountryCode === 'CN' ? 1 : 14 // 1- 国内注册 或者 14- 境外注册
            };
            if (v.tabName === 'mobileRegister') {
              query.email = v.registerForm.email;
              query.registryType = 1;
              query.mobile = v.registerForm.mobile;
            } else {
              query.mobile = v.registerForm.emailRegisterMobile;
              query.email = v.registerForm.registerEmail;
              query.registryType = 2;
            }
            if (v.from === 'miaoshou') {
              // 1ERP2.0、2ERP3.0、3商城注册、4Shopify、5人工添加、6H5、7MIAOSHOU
              query.registerSource = 7;
            }
            // this.from === 'miaoshou
            v.axios.post(api.post_ymsDistributorMerchant_registry, query).then(response => {
              if (response.data.code === 0) {
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006545'));
                v.toLogin();
              }
            });
          } else {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001000'));
            return false;
          }
        }
      });
    },
    // 获取图片验证码
    getCaptcha() {
      // 获取当前的时间戳
      this.axios.get(api.yms_get_captcha).then((response) => {
        this.captchaImage = 'data:image/png;base64,' + response.data.datas.base64ImageCode;
        this.uid = response.data.datas.uid;
        this.registerForm.uid = response.data.datas.uid;
      });
    },
    // 注册页埋点及事件上报(TMS跳转到yms注册页面携带有adid参数时才触发)
    incidentReporting() {
      let v = this;
      v.adid = null;
      let urlAdid = getQueryString('adid');
      let adidToken = getAdidToken('adidToken');
      let adid = urlAdid || adidToken;
      if (urlAdid || adidToken) {
        let query = {
          adid: adid
        };
        v.axios.post(api.post_ymsDistributorMerchant_tokerLinkEventReport, query).then(response => {
          if (response.data.code === 0) {
            v.adid = adid;
            if (urlAdid) {
              setAdidToken(adid);
            }
          }
        });
      }
    },
    // 切换账号/短信登录
    changeTab() {
      let v = this;
      v.$refs['registerForm'].resetFields();
      v.$nextTick(() => {
        v.registerForm.mobileCountryCode = 'CN';
        v.$forceUpdate();
      });
    },
    // 获取分销商币种
    async systemCurrencyData() {
      let response = await this.axios.get(api.get_ymsCurrencyConfig_query + `?merchantType=3`);
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        this.distributorCurrencyList = data.map((item) => {
          item.currencyNameCode = item.currencyName + ' ' + item.targetCurrencyCode;
          return item;
        });
      }
    }
  },
  computed: {
    fromListing() {
      return this.$store.state.fromListing;
    },
    showLeft() {
      let show = true;
      if (this.fromListing) {
        show = false;
      }
      return show;
    },
    showMiddle() {
      let show = true;
      if (this.fromListing || this.from === 'miaoshou') {
        show = false;
      }
      return show;
    },
    showRight() {
      let show = true;
      if (this.from === 'miaoshou') {
        return false;
      }
      return show;
    },
  },
  components: {
    loginForm,
    privacyPolicy,
    termsOfService
  }
};
</script>

<style>
.registerForm_form .ivu-input-icon {
  width: 40px;
  height: 40px;
  line-height: 40px;
}

.registerForm_form .ivu-input-icon, .registerForm_form .ivu-input-suffix i {
  width: 40px;
  height: 40px;
  line-height: 40px;
}

.tt-auth .conter_form {
  padding: 0
}
</style>

<style lang="less" scoped>
@import "src/assets/styles/shopping/common";

.no-float {
  float: none !important;
  margin: 0 auto;
}

.mt5 {
  margin-top: 8px;
}

.register {
  width: 1000px;
  margin: 0 auto;
  position: relative;

  .line {
    width: 1px;
    height: 465px;
    background-color: #D7D7D7;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -300px;
  }
}

.tt-auth {
  width: 360px;
  float: right;
  margin-top: 170px;

  .title {
    font-size: 28px;
    color: #555555;
    margin-bottom: 20px;
  }

  .tp {
    font-size: 16px;
    color: #333333;
    margin-bottom: 5px;
  }
}


.registerForm_form {
  padding-top: 40px;
  width: 360px;
  float: left;
  background-color: #fff;
  min-height: 800px;

  .title {
    text-align: center;
    font-size: 28px;
    margin: 0 auto 20px;
    color: #2E3E51;
  }

  /deep/ .ivu-form-item {
    input {
      height: 40px;
      line-height: 40px;
    }

    .verificationcode_box {
      display: flex;
      justify-content: space-between;
      align-items: center;

      input {
        width: 235px;
      }

      img {
        cursor: pointer;
      }
    }

    .verificationcode_botton {
      width: 230px;
      text-align: right;

      .ivu-btn {
        width: 110px;
        font-size: 13px !important;
      }
    }

    .set_verificationcode_box {
      .ivu-input-wrapper {
        width: 180px !important;

        input {
          width: 180px !important;
        }
      }

      .verificationcode_botton {
        width: 165px;
        text-align: right;

        .ivu-btn {
          width: 100%;
          font-size: 12px !important;
          padding: 0 10px;
        }
      }
    }
  }

  .link_box {
    margin-top: 30px;
    display: flex;
    align-items: center;

    .link_item {
      display: flex;
      align-items: center;

      img {
        margin-right: 5px;
      }

      .line {
        display: inline-block;
        margin: 0 8px;
      }

      .txt {
        font-size: 14px;
        cursor: pointer;

        &:hover {
          color: @subject_color;
        }
      }
    }
  }

  .select_color {
    color: #fd5425;
    text-decoration: none;

    &:hover {
      color: #f90;
    }
  }

  /deep/ .reset_select_input {
    width: 120px;
    line-height: 40px;
    height: 40px;
    display: flex;
    align-items: center;

    .ivu-select-selection {
      height: 40px;
    }
  }

  /deep/ .reset_select {
    .ivu-select-selection {
      height: 40px;
    }
  }

  /deep/ .ivu-input-group-prepend {
    background-color: transparent;
  }

  /deep/ .ivu-tabs-nav {
    width: 100%;

    .ivu-tabs-tab {
      font-size: 16px;
      margin-right: 0;
      width: 50%;
      text-align: center;
    }

    .ivu-tabs-ink-bar {
      width: 50% !important;
    }
  }
}
</style>
